import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MyPlugin from "./db";
import { Fragment } from "vue-fragment";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUser, faUsers, faImage, faSave, faUndo, faProjectDiagram, faPlusSquare, faMinusSquare, faBan, faCaretRight, faCaretLeft, faCaretDown, faPercentage, faTrash, faBackspace, faAlignLeft, faPlus, faMinus, faFileDownload, faObjectUngroup, faDiceD6, faRunning, faComment, faCommentAlt, faTasks, faStoreAlt, faSuitcase, faFan, faFileArchive } from '@fortawesome/free-solid-svg-icons'

library.add(faUser, faUsers, faImage, faSave, faUndo, faProjectDiagram, faPlusSquare, faMinusSquare, faBan, faCaretRight, faCaretLeft, faCaretDown, faPercentage, faTrash, faBackspace, faAlignLeft, faPlus, faMinus, faFileDownload, faObjectUngroup, faDiceD6, faRunning, faComment, faCommentAlt, faTasks, faStoreAlt, faSuitcase, faFan, faFileArchive)

Vue.component('fa-icon', FontAwesomeIcon)
Vue.component('fragment', Fragment);

Vue.config.productionTip = false
Vue.use(MyPlugin, {dbname: 'sml-tk'});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
